import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamActiveDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamActiveDeleteCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStreamActiveDelete) {
    JsonSchemaValidator.assert(RoomStreamActiveDeleteCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      }
    };
  }
}

interface RoomStreamActiveDelete {
  roomId: RoomId;
  streamId: StreamId;
}
